module.exports = __webpack_public_path__ + "img/step3.c0decc02.png";